import { CoreModel } from '../core/core.model';
import { IconModel } from '../icon/icon.model';
import { InputModel } from '../input/input.model';
export class DatatableModel extends CoreModel {
/**
 * If to show ngx-datatable footer
 */
showTableFooter?: boolean;
/**
 * If to show ngx-datatable footer count text
 */
showTableCount?: boolean;
/**
 * If to show ngx-datatable footer pager
 */
showTablePager?: boolean;
/**
 * The height of the header in pixels. Type any. Pass a false for no header. Default: 42.
 */
headerHeight?: any;
/**
 * The height of the footer in pixels. Type any. Pass a false for no footer. Default: 42.
 */
footerHeight?: any;
/**
 * It is array with rows json objects.
 */
rows?: any[];
/**
 * It is height of each row. Can be numeric (nember will be transformed to pixels) or 'auto'. Default: 50.
 */
rowHeight?: any;
/**
 * The mode which the columns are distributed across the table. Type string. Can be: flex, force, standard. Default: force.
 */
columnMode?: string;
/**
 * It is rows quontity per page. Type number. Default: 3.
 */
limit?: number;
/**
 * It is boolean value to use or not row details section. Default: false.
 */
expandable?: boolean;
/**
 * Means how rows can be expanded at one time. Default: multiple. Can be: multiple or single.
 */
rowExpand?: string;
/**
 * It is height of row in pixels. Type number. Default: 130.
 */
detailsHeight?: number;
/**
 * CfIcon component for the row expanding icon.
 */
expandIcon?: IconModel;
/**
 * CfIcon component for the row collapsing icon.
 */
collapseIcon?: IconModel;
/**
 * It is boolean value to show or not rows section checkboxes. Default: false.
 */
selectable?: boolean;
/**
 * Array with sorting objects. Default: [].
 * Rows can sorted by multipe columns. Each sorting object is a json object with two properties:
 * <b>prop</b>(property name by which to sort rows) and <b>dir</b>(sort direction. Can be: <b>asc</b> or <b>desc</b>).
 */
sorted?: any[];
/**
 * Array for selected items.
 */
selected?: any[];
/**
 * @hidden 
 * It is the constructor for the Datatable component. It takes the values from component to create the Datatable object.
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function DatatableModel_tsickle_Closure_declarations() {
/**
 * If to show ngx-datatable footer
 * @type {?}
 */
DatatableModel.prototype.showTableFooter;
/**
 * If to show ngx-datatable footer count text
 * @type {?}
 */
DatatableModel.prototype.showTableCount;
/**
 * If to show ngx-datatable footer pager
 * @type {?}
 */
DatatableModel.prototype.showTablePager;
/**
 * The height of the header in pixels. Type any. Pass a false for no header. Default: 42.
 * @type {?}
 */
DatatableModel.prototype.headerHeight;
/**
 * The height of the footer in pixels. Type any. Pass a false for no footer. Default: 42.
 * @type {?}
 */
DatatableModel.prototype.footerHeight;
/**
 * It is array with rows json objects.
 * @type {?}
 */
DatatableModel.prototype.rows;
/**
 * It is height of each row. Can be numeric (nember will be transformed to pixels) or 'auto'. Default: 50.
 * @type {?}
 */
DatatableModel.prototype.rowHeight;
/**
 * The mode which the columns are distributed across the table. Type string. Can be: flex, force, standard. Default: force.
 * @type {?}
 */
DatatableModel.prototype.columnMode;
/**
 * It is rows quontity per page. Type number. Default: 3.
 * @type {?}
 */
DatatableModel.prototype.limit;
/**
 * It is boolean value to use or not row details section. Default: false.
 * @type {?}
 */
DatatableModel.prototype.expandable;
/**
 * Means how rows can be expanded at one time. Default: multiple. Can be: multiple or single.
 * @type {?}
 */
DatatableModel.prototype.rowExpand;
/**
 * It is height of row in pixels. Type number. Default: 130.
 * @type {?}
 */
DatatableModel.prototype.detailsHeight;
/**
 * CfIcon component for the row expanding icon.
 * @type {?}
 */
DatatableModel.prototype.expandIcon;
/**
 * CfIcon component for the row collapsing icon.
 * @type {?}
 */
DatatableModel.prototype.collapseIcon;
/**
 * It is boolean value to show or not rows section checkboxes. Default: false.
 * @type {?}
 */
DatatableModel.prototype.selectable;
/**
 * Array with sorting objects. Default: [].
 * Rows can sorted by multipe columns. Each sorting object is a json object with two properties:
 * <b>prop</b>(property name by which to sort rows) and <b>dir</b>(sort direction. Can be: <b>asc</b> or <b>desc</b>).
 * @type {?}
 */
DatatableModel.prototype.sorted;
/**
 * Array for selected items.
 * @type {?}
 */
DatatableModel.prototype.selected;
}

